module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', [_c('b-switch', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }, [_c('strong', [_vm._v("Progress")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Type",
      "label-position": "on-border"
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.progress
    },
    model: {
      value: (_vm.progressType),
      callback: function($$v) {
        _vm.progressType = $$v
      },
      expression: "progressType"
    }
  }, [_c('option', {
    attrs: {
      "value": "is-primary"
    }
  }, [_vm._v("is-primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-info"
    }
  }, [_vm._v("is-info")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-success"
    }
  }, [_vm._v("is-success")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-warning"
    }
  }, [_vm._v("is-warning")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-danger"
    }
  }, [_vm._v("is-danger")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-white"
    }
  }, [_vm._v("is-white")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-light"
    }
  }, [_vm._v("is-light")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-dark"
    }
  }, [_vm._v("is-dark")])])], 1)], 1)], 1), _vm._v(" "), _c('b-carousel', {
    attrs: {
      "progress": _vm.progress,
      "progress-type": _vm.progressType
    }
  }, _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color))
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.title))])])])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f631c36e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExProgress.vue
// module id = 985
// module chunks = 3 163